/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */

import { environment as jsonEnvironment } from 'environment';

interface IEnvironmentVariables {
	production: boolean;
	logLineNumbers: boolean;
	firebase: {
		apiKey: string;
		authDomain: string;
		databaseURL: string;
		projectId: string;
		storageBucket: string;
		attachmentBucket: string;
	};
	refUrl: string;
	developerMode: boolean;
	defaultUserTier: string;
	segmentKey: string;
	useCloud: boolean;
	restApiUrl: string;
	additionalErrorIdentifier: string;
	useFirebaseFunctionsEmulator: boolean;
}

interface IDefaultEnvironmentVariables {
	additionalErrorIdentifier: string;
	useFirebaseFunctionsEmulator: boolean;
}

const DEFAULT_VALUES: IDefaultEnvironmentVariables = {
	additionalErrorIdentifier: null,
	useFirebaseFunctionsEmulator: false,
};

export const environment: IEnvironmentVariables = {
	...DEFAULT_VALUES,
	...jsonEnvironment,
};
